import type { QuestionReportResponse } from '@signalvote/shared';
import { apiJson } from './apiFetch';
import { campaignHeaders, defineQuery } from '@/lib/data';

/** The selected campaign's answer report; a contact or answer write refreshes it. */
export const useCampaignQuestionReport = defineQuery({
  key: () => ['analytics', 'campaignQuestionReport'],
  reads: 'GET /api/campaigns/{id}/questions/report',
  staleTime: 10 * 60 * 1000,
  fetch: (_: undefined, { signal, campaignId }) =>
    apiJson<QuestionReportResponse>(`/api/campaigns/${campaignId}/questions/report`, {
      signal,
      headers: campaignHeaders(campaignId),
      error: 'Failed to fetch question report',
    }),
});
